import { Component } from '@angular/core';

@Component({
  selector: 'app-image-showing',
  standalone: true,
  templateUrl: './image-showing.component.html',
  styleUrls: ['./image-showing.component.scss']
})
export class ImageShowingComponent {
  aiImagePath = 'assets/A.png';
}
